<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Agendar Atendimento</span>
  </div>
  <div class="row">
    <div class="col-md-4 col-lg-2">
      <label for="cpf">CPF</label><br />
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="profissional.cpf" id="cpf" readonly disabled />
    </div>

    <div class="col-md-8 col-lg-5">
      <label for="nome">Nome</label><br />
      <input type="text" class="form-control form-input-component" v-model="profissional.nome" id="nome" readonly disabled />
    </div>

    <div class="col-md-12 col-lg-5">
      <label>Especialidade</label><br />
      <input type="text" class="form-control form-input-component" v-model="profissional.especialidade.nome" readonly disabled />
    </div>
  </div>

  <a-modal @cancel="cancelEventCreation()" v-model:visible="showEventCreationDialog" title="Agendar Consulta" width="1000px">
    <form class="row needs-validation" novalidate id="formulario" name="formulario">
      <div class="row" style="margin-bottom: 15px">
        <div class="col-9">
          <label>Paciente</label>
          <a-auto-complete v-model:value="pacienteNome" class="form-control" id="auto-complete-pesquisarDadosMilitarPeloNomeOuRg" @search="pesquisarDadosMilitarPeloNomeOuRg">
            <template v-slot:dataSource>
              <a-select-option v-for="item in dataPacientes" :key="item.nome" @click="selecionarPaciente(item)"> {{ item.cpf }} - {{ item.nome }} {{ item.rgMilitar }} </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>
      <div class="row" style="margin-bottom: 15px">
        <div class="col-3">
          <label>Data Consulta</label>
          <input type="text" v-model="form.dataConsulta" class="form-control form-input-component" id="dataConsulta" v-bind:class="{ 'is-invalid': submitted && !form.dataConsulta }" ref="dataConsulta" v-mask="'##/##/####'" placeholder="Ex: 20/02/2023" required />
        </div>
        <div class="col-3">
          <label for="horaInicio">Hora de início</label>
          <input type="text" v-model="form.horaInicio" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaInicio }" ref="horaInicio" class="form-control form-input-component" id="horaInicio" />
        </div>
        <div class="col-3">
          <label for="horaFim">Hora Término</label>
          <input type="text" v-model="form.horaFim" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaFim }" ref="horaFim" class="form-control form-input-component" id="horaFim" />
        </div>
      </div>

      <div class="row" style="margin-bottom: 15px">
        <div class="col-5">
          <label for="tipoAgenda">Modo da Consulta</label>
          <select class="form-select form-input-component" v-model="form.tipoAgenda" required v-bind:class="{ 'is-invalid': submitted && !form.tipoAgenda }" id="tipoAgenda">
            <option>PRESENCIAL</option>
            <option>VIRTUAL</option>
          </select>
        </div>

        <div class="col-4">
          <label for="convenio">Convênio</label>
          <select class="form-select form-input-component" v-model="form.convenio" required v-bind:class="{ 'is-invalid': submitted && !form.convenio }" id="convenio">
            <option>IPASGO</option>
            <option>PARTICULAR</option>
            <option>DOACAO</option>
          </select>
        </div>
      </div>
      <div class="row" style="margin-bottom: 15px">
        <div class="col-9">
          <label for="categoriaAtendimento">Categoria do Atendimento</label>
          <select class="form-select form-input-component" v-model="form.categoriaAtendimento" required v-bind:class="{ 'is-invalid': submitted && !form.categoriaAtendimento }" id="categoriaAtendimento">
            <option v-for="item in listaCategoriaAtendimento" :key="item.id" :value="item.descricao">
              {{ item.descricao }}
            </option>
          </select>
        </div>
      </div>
      <div class="row" style="margin-bottom: 15px">
        <div class="col-9">
          <label for="unidadeAtendimento">Unidade Atendimento</label>
          <select class="form-select form-input-component" v-model="form.unidadeAtendimento" required v-bind:class="{ 'is-invalid': submitted && !form.unidadeAtendimento }" id="unidadeAtendimento">
            <option v-for="item in listaUnidade" :key="item.id" :value="item.unidadeNome">
              {{ item.unidadeNome }}
            </option>
          </select>
        </div>
      </div>

      <div class="row" style="margin-bottom: 15px">
        <div class="col-9">
          <label>Observação</label>
          <textarea type="text" v-model="form.observacao" class="form-control form-input-component" id="observacao" required> </textarea>
        </div>
      </div>
    </form>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="saveAndContinue()">Salvar</button>
      <button type="button" class="btn btn-danger" v-if="form.id" @click="excluirAgendamento()">Excluir</button>
      <button type="button" class="btn btn-primary" @click="cancelEventCreation">Cancelar</button>
    </template>
  </a-modal>
  <Dialog
    header="Pesquisa Paciente"
    v-model:visible="showPesquisaPaciente"
    style="
       {
        width: 60vw;
        backgroundcolor: #dcdeff;
      }
    "
    id="pesquisarPacientes"
  >
    <a-table :dataSource="pacientes" :columns="columns" :key="id">
      <template #action="{ record }">
        <a @click="selecionarPaciente(record)" title="Selecionar"><i class="fa-solid fa-hand-point-left custom-icon"></i></a>
      </template>
      <!--
      <template #unidade="{ record }">
          <a-popconfirm
              v-if="dataSource.length"
              title="Confirma exclusão ?"
              @confirm="onDelete(record.key)">
              <a>Delete</a>
          </a-popconfirm>
      </template>
      -->
    </a-table>
  </Dialog>

  <br />
  <vue-cal class="vuecal--full-height-delete vuecal--blue-theme" click-to-navigate locale="pt-br" hide-view-selector :time-from="6 * 60" :timeTo="20 * 60" :disable-views="['years', 'year', 'day']" :hide-weekdays="[]" :editable-events="{ title: false, create: true, delete: false, resize: false, drag: false }" :resizeX="true" :snapToTime="60" :dragToCreateEvent="true" :minDate="new Date()" :events="allEvents" @view-change="onViewChange($event)" :on-event-click="onEventClick" :on-event-create="onEventCreate" @event-drag-create="showEventCreationDialog = true" />
  <br />
</template>

<script>
import { getDataUser } from '@/utils';
import { getProfissionalByCpf } from '@/components/service/profissionalService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { getAllEvents, getConsulta, gravarConsulta } from '@/components/service/agenda';
import { excluirAgendamento } from '@/components/service/agendamento-medico';
import { getCategoriaAtendimento, getUnidadesTrabalho } from '@/config/servicos-utils';
import { formatarData, weekYear } from '@/utils/servicos-utils';
import VueCal from 'vue-cal';
import { getPaciente, getPacienteById } from '@/components/service/pacienteService';
import { required } from '@vuelidate/validators';

export default {
  name: 'FormAgendarAtendimento',
  components: { VueCal },
  setup() {
    return { dataUser: getDataUser() };
  },
  data() {
    return {
      submitted: false,
      v$: useVuelidate(),
      dataPacientes: [],
      allEvents: [],
      listaUnidade: [],
      listaCategoriaAtendimento: [],
      profissional: undefined,
      showEventCreationDialog: false,
      showPesquisaPaciente: false,
      selectedEvent: undefined,
      pacientes: [],
      pacienteNome: undefined,
      pacienteCpf: undefined,
      currentWeekYear: undefined,
      form: {
        idConsulta: undefined,
        pacienteId: undefined,
        profissionalId: undefined,
        secretariaCpf: this.dataUser.cpf,
        secretariaNome: this.dataUser.nome,
        dataConsulta: undefined,
        horaInicio: undefined,
        horaFim: undefined,
        tipoAgenda: undefined,
        convenio: undefined,
        categoriaAtendimento: undefined,
        unidadeAtendimento: undefined,
        observacao: undefined,
      },
      pacienteDTO: {
        cpf: undefined,
        nome: undefined,
      },
      columns: [
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      pacienteNome: {
        required,
      },
      pacienteCpf: {
        required,
      },
      form: {
        dataConsulta: {
          required,
        },
        horaInicio: {
          required,
        },
        horaFim: {
          required,
        },
        tipoAgenda: {
          required,
        },
        convenio: {
          required,
        },
        unidadeAtendimento: {
          required,
        },
        categoriaAtendimento: {
          required,
        },
      },
    };
  },
  methods: {
    selecionarPaciente(rec) {
      this.pacienteCpf = rec.cpf;
      this.pacienteNome = rec.nome;
      this.form.pacienteId = rec.id;
      this.showPesquisaPaciente = false;
    },
    async pesquisarPaciente() {
      this.pacienteDTO.nome = this.pacienteNome;
      this.pacienteDTO.cpf = this.pacienteCpf;
      getPaciente(this.pacienteDTO)
        .then((r) => {
          this.pacientes = r.data.pacientes;
        })
        .catch((error) => {
          openNotification(typesNotification.error, 'Não foi possível encontrar pacientes com os parâmetros informados!');
          console.log(error);
        });
      this.showPesquisaPaciente = true;
    },
    async pesquisarDadosMilitarPeloNomeOuRg(value) {
      if (value.length > 2) {
        await getPaciente({ any: value }).then((r) => {
          this.dataPacientes = r.data.pacientes;
          console.log(this.dataPacientes);
        });
      } else {
        this.dataPacientes = [];
      }
    },

    onClickTodos() {},
    onEventClick(event, deleteEventFunction) {
      console.log('teste');
      if (event.type != 'CONSULTA' && event.type != 'PRESENCIAL' && event.type != 'VIRTUAL') {
        openNotification(typesNotification.error, 'Evento Não Editável');
        return;
      }
      if (event.type === 'PRESENCIAL' || event.type === 'VIRTUAL') {
        this.showEventCreationDialog = true;
        this.onEventCreate(event, deleteEventFunction);
      } else {
        getConsulta(event.id).then((rs) => {
          this.form.id = rs.data.id;
          this.form.dataConsulta = rs.data.dataConsulta;
          this.form.horaInicio = rs.data.horaInicio;
          this.form.horaFim = rs.data.horaFim;
          this.form.pacienteId = rs.data.pacienteId;
          getPacienteById(rs.data.pacienteId).then((rs) => {
            this.pacienteNome = rs.data.nome;
            this.pacienteCpf = rs.data.cpf;
          });
          this.form.tipoAgenda = rs.data.tipoAgenda;
          this.form.convenio = rs.data.convenio;
          this.form.categoriaAtendimento = rs.data.categoriaAtendimento;
          this.form.unidadeAtendimento = rs.data.unidadeAtendimento;
          this.form.observacao = rs.data.observacao;
          this.deleteEventFunction = this.deleteEditDialog;
          this.showEventCreationDialog = true;
        });
      }
    },
    deleteEditDialog() {
      if (document.getElementById('formulario').value) {
        document.getElementById('formulario').remove();
      }
    },
    onViewChange(event) {
      console.log(event);
    },
    onEventCreate(event, deleteEventFunction) {
      setTimeout(() => {
        this.selectedEvent = event;
        this.form.dataConsulta = event.start.format('DD/MM/YYYY');
        this.form.horaInicio = formatarData(event.start, 'HH:mm');
        this.form.horaFim = formatarData(event.end, 'HH:mm');
        this.deleteEventFunction = deleteEventFunction;
      }, 500);
      return event;
    },
    cancelEventCreation() {
      this.pacienteNome = undefined;
      this.pacienteCpf = undefined;
      this.form.id = undefined;
      this.form.pacienteNome = undefined;
      this.form.pacienteCpf = undefined;
      this.form.pacienteId = undefined;
      this.form.categoriaAtendimento = undefined;
      this.form.unidadeAtendimento = undefined;
      this.form.convenio = undefined;
      this.form.tipoAgenda = undefined;
      this.form.observacao = undefined;
      this.showEventCreationDialog = false;
      this.selectedEvent = {};
      this.deleteEventFunction();
    },
    atualizarTabela(weekYear) {
      let localCpf = this.$route.query.cpf;
      this.currentWeekYear = weekYear;
      getAllEvents(localCpf, weekYear).then((rs) => {
        this.allEvents = rs.data;
        this.allEvents.forEach((item) => {
          if (item.type === 'BLOQUEIO') {
            item.class = 'evento-bloqueado';
          } else if (item.type === 'CONSULTA') {
            item.class = 'evento-consulta';
          } else if (item.type === 'PRESENCIAL' || item.type === 'VIRTUAL') {
            item.class = 'evento-alocado';
          }
        });
      });
    },
    async excluirAgendamento() {
      if (confirm('Deseja realmente excluir o agendamento da consulta?')) {
        await excluirAgendamento(this.form.id).then(() => {
          this.showEventCreationDialog = false;
          this.form.horaInicio = undefined;
          this.form.horaFim = undefined;
          this.submitted = false;
          this.atualizarTabela(this.currentWeekYear);
          openNotification(typesNotification.success, 'Agendamento da consulta excluido com sucesso!');
        });
      }
    },
    async saveAndContinue() {
      this.v$.$validate();
      if (!this.form.pacienteId) {
        openNotification(typesNotification.error, 'Você precisa pesquisar um Paciente');
      } else {
        if (this.v$.$error) {
          this.submitted = true;
          openNotification(typesNotification.error, 'Informe os campos obrigatórios');
        } else {
          this.form.secretariaCpf = this.profissional.cpf;
          this.form.secretariaNome = this.profissional.nome;
          await gravarConsulta(this.form).then(() => {
            // recarregar lista aqui
            this.showEventCreationDialog = false;
            this.form.horaInicio = undefined;
            this.form.horaFim = undefined;
            this.submitted = false;
            this.atualizarTabela(this.currentWeekYear);
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
            this.cancelEventCreation();
          });
        }
      }
    },
  },
  created() {
    console.log(this.$route.query.cpf);
    getProfissionalByCpf(this.$route.query.cpf)
      .then((r) => {
        this.profissional = r.data;
        this.form.profissionalId = this.profissional.id;
      })
      .catch(() => {
        openNotification(typesNotification.error, 'Usuário não cadastrado como Profissional de Saúde!');
      });

    getUnidadesTrabalho(this.$route.query.cpf).then((rs) => {
      this.listaUnidade = rs.data;
    });
    getCategoriaAtendimento().then((rs) => {
      this.listaCategoriaAtendimento = rs.data;
    });

    this.currentWeekYear = weekYear();
    this.atualizarTabela(this.currentWeekYear);
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.evento-alocado {
  background-color: #a4e6d2e6;
  border: 1px solid rgb(144, 210, 190);
  color: #666;
}

.evento-bloqueado {
  background-color: #ff6666d9;
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}

.evento-consulta {
  background-color: #bce1ff;
  border: 1px solid #0087ca;
  color: #666;
}
</style>
